<template>
  <base-dialog-form
    ref="userProfileDialog"
    class="pure"
    :title="$t('profile')"
    color="secondary"
    :type="type"
    icon="mdi-account"
  >
    <v-container
      id="profile-page"
      fluid
      tag="section"
    >
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <user-card
            :masterId="masterId"
            button-color="info"
          ></user-card>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <profile-data
            @isUpdated="emitUpdated"
            @tabChange="onTabChange"
            :startTab="startTab"
            :masterId="masterId"
            button-color="info"
          ></profile-data>
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
import userCard from "@/widget/userCard.vue";
import profileData from "@/widget/profileData.vue";
export default {
  name: "profile-page",
  components: {
    userCard,
    profileData,
  },
  props: {
    paramsType: {
      type: String,
      default: null,
    },
    paramsMasterId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      type: null,
      masterId: null,
      startTab: null,
    };
  },
  methods: {
    emitUpdated: function (data) {
      this.$emit("isUpdated", "true");
    },
    onTabChange(value) {
      // persiste la tab solo quando la pagina e' la route /portal/profile, non nei dialoghi
      if (this.type !== "plain") return;
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
    open(masterId, startTab) {
      this.type = "dialog";
      this.masterId = masterId;
      this.startTab = startTab;
      this.$refs.userProfileDialog.open();
    },
    onSelect: function (items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    if (this.paramsType) {
      this.masterId = this.paramsMasterId;
      this.type = this.paramsType;
      this.startTab = parseInt(this.$route.query.tab, 10) || 0;

      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    paramsMasterId: function (newVal, oldVal) {
      if (newVal) this.masterId = newVal;
    },
  },
};
</script>
<style lang="scss">
#profile-page {
  padding-left: 0px;
  padding-right: 0px;
}
.text-right {
  display: flex;
}
</style>
